//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HButton from '../HButton'
import Wrapper from './Wrapper'
import {prefix} from '../../common/mixins'

export default {
  name: 'Alert',
  components: {
    HButton,
    Wrapper,
  },
  mixins: [prefix],
  /* eslint-disable vue/require-default-prop */
  props: {
    title: String,
    content: String,
    noMask: Boolean,
    buttons: {
      type: Array,
      default: () => [
        {
          type: 'confirm',
          text: '确定',
          color: '',
          bgColor: '',
          alone: false,
        },
      ],
    },
  },
  /* eslint-enable */
  data () {
    return {
      show: false,
    }
  },
  computed: {
    buttonClass () {
      return this.buttons[0].alone ? 'alone' : ''
    },
    buttonStyle () {
      return {
        color: this.buttons[0].color,
        backgroundColor: this.buttons[0].bgColor,
      }
    },
  },
  methods: {
    hide () {
      this.show = false
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Dialog/Alert.vue